module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audio-player-lesson-container"
  }, [_c('div', {
    staticClass: "controls-row"
  }, [_c('img', {
    class: {
      disabledBtn: !_vm.audioFile
    },
    attrs: {
      "width": _vm.hideProgressBar ? '50px' : '25px',
      "height": _vm.hideProgressBar ? '50px' : '25px',
      "src": _vm.audio && _vm.audio.paused ?
        require('../../assets/svg/play-white.svg').default :
        require('../../assets/svg/pause-white.svg').default
    },
    on: {
      "click": _vm.play
    }
  }), _vm._v(" "), (!_vm.hideProgressBar && _vm.audioFile) ? _c('button', {
    staticClass: "speed-btn lesson-speed-btn",
    attrs: {
      "title": ("מהירות: " + _vm.playbackRate + "x")
    },
    on: {
      "click": _vm.cycleSpeed
    }
  }, [_vm._v("\n      " + _vm._s(_vm.playbackRate) + "x\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', [(!_vm.hideProgressBar) ? _c('input', {
    ref: "progressBar",
    staticClass: "slider",
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "type": "range",
      "name": "progressBar",
      "id": "progressBar"
    },
    domProps: {
      "value": _vm.progressBar
    },
    on: {
      "input": _vm.changeProgress
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62c62ae1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/AudioPlayerLesson.vue
// module id = 466
// module chunks = 1 8